import ApiHelper from "../../ApiHelper";
import API_ENDPOINTS from "../../endpoints";

class CollegeHelper {
  async getAllColleges() {
    try {
      const response = await ApiHelper.get(API_ENDPOINTS.ADMIN.COLLEGES);
      return response;
    } catch (error) {
      throw new Error(`Failed to fetch colleges: ${error.message}`);
    }
  }

  async getCollegeById(collegeId) {
    try {
      const response = await ApiHelper.get(
        API_ENDPOINTS.COLLEGES.BY_ID(collegeId)
      );
      return response;
    } catch (error) {
      throw new Error(`Failed to fetch college by ID: ${error.message}`);
    }
  }

  async createCollege(collegeData) {
    try {
      // Check if collegeData is FormData (for file upload)
      const isFormData = collegeData instanceof FormData;
      
      const response = await ApiHelper.post(
        API_ENDPOINTS.ADMIN.CREATE_COLLEGE,
        collegeData,
        isFormData ? {
          // Remove Content-Type header - let axios set it with proper boundary
          headers: {
            'Content-Type': undefined  // This removes the default application/json header
          }
        } : undefined
      );
      return response;
    } catch (error) {
      throw new Error(`Failed to create college: ${error.message}`);
    }
  }

  async updateCollege(collegeId, collegeData) {
    try {
      // Check if collegeData is FormData (for file upload)
      const isFormData = collegeData instanceof FormData;
      
      const response = await ApiHelper.put(
        API_ENDPOINTS.ADMIN.COLLEGE_BY_ID(collegeId),
        collegeData,
        isFormData ? {
          // Remove Content-Type header - let axios set it with proper boundary
          headers: {
            'Content-Type': undefined  // This removes the default application/json header
          }
        } : undefined
      );
      return response;
    } catch (error) {
      throw new Error(`Failed to update college: ${error.message}`);
    }
  }

  async toggleCollegeSubscription(collegeId) {
    try {
      const response = await ApiHelper.post(
        API_ENDPOINTS.ADMIN.TOGGLE_COLLEGE_SUBSCRIPTION,
        { collegeId }
      );
      return response;
    } catch (error) {
      throw new Error(
        `Failed to toggle college subscription: ${error.message}`
      );
    }
  }
}

export default new CollegeHelper();
